var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 80.0283C62.0914 80.0283 80 62.1197 80 40.0283C80 17.9369 62.0914 0.0283203 40 0.0283203C17.9086 0.0283203 0 17.9369 0 40.0283C0 62.1197 17.9086 80.0283 40 80.0283Z",
    fill: "url(#paint0_linear_110_4147)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.0283C0 62.0745 17.8218 79.8963 40 79.8963C62.0462 79.8963 79.868 62.0745 79.868 40.0283",
    fill: "url(#paint1_linear_110_4147)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2241 50.5903H35.7752L32.6069 10.9863H47.3924L44.2241 50.5903Z",
    fill: "#EBFFF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5242 10.7217L44.2239 50.5897H36.0391",
    fill: "#D6EAE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0358 69.0956L47.0356 62.0938L40.0338 55.0939L33.0339 62.0957L40.0358 69.0956Z",
    fill: "#EBFFF6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_4147",
    x1: 8.70311e-7,
    y1: 5.74257,
    x2: 81.6195,
    y2: 7.86912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_110_4147",
    x1: 8.68875e-7,
    y1: 42.876,
    x2: 81.3186,
    y2: 47.1204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attention-icon.a116cbecf7c3d82183eb50a24bf7e5f8.svg";
export { ForwardRef as ReactComponent };